// Arte de temporada: Día de Muertos y Halloween (dibujado a mano en SVG, sin emojis ni imágenes externas).
// Paleta: negro y rojo de la marca + naranja cempasúchil, morado, rosa mexicano y hueso como acentos.
// Lo prende App.js solo cuando la temporada está activa (TEMPORADAS).

const NARANJA = "#FF8A1F";
const AMARILLO = "#FFB627";
const MORADO = "#9B4DFF";
const ROSA = "#E4007C";
const ROJO = "#FF0000";
const HUESO = "#EDE8E0";
const NEGRO = "#0A0A0A";

// ─── PAPEL PICADO ───
// Banderitas con recortes (calavera, flor, murciélago, rombos). Los recortes son máscaras: el negro es el hueco.
const MOTIVOS = ["calavera", "flor", "murcielago", "rombos"];
const COLORES_PP = [NARANJA, MORADO, ROSA, ROJO, AMARILLO, MORADO, NARANJA, HUESO];

function DefsPapel() {
  const borde = Array.from({ length: 6 }, (_, i) => <circle key={i} cx={7 + i * 9.2} cy="66" r="1.6" fill="#000" />);
  const marco = <rect x="3" y="3" width="54" height="56" fill="none" stroke="#000" strokeWidth="1.2" strokeDasharray="3 2.4" />;
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
      <defs>
        <mask id="pp-calavera" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="76">
          <rect width="60" height="76" fill="#fff" />{marco}{borde}
          <path d="M30 13c-9 0-15 6-15 14 0 5 2 8 5 10v5c0 2 1 3 3 3h14c2 0 3-1 3-3v-5c3-2 5-5 5-10 0-8-6-14-15-14z" fill="#000" />
          <ellipse cx="24.5" cy="28" rx="4" ry="4.4" fill="#fff" /><ellipse cx="35.5" cy="28" rx="4" ry="4.4" fill="#fff" />
          <path d="M30 33l-2 4h4z" fill="#fff" />
          <path d="M24 41v4M28 41v4M32 41v4M36 41v4" stroke="#fff" strokeWidth="1.3" />
        </mask>
        <mask id="pp-flor" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="76">
          <rect width="60" height="76" fill="#fff" />{marco}{borde}
          {Array.from({ length: 8 }, (_, i) => <ellipse key={i} cx="30" cy="20" rx="4.2" ry="9" transform={`rotate(${i * 45} 30 30)`} fill="#000" />)}
          <circle cx="30" cy="30" r="5" fill="#fff" /><circle cx="30" cy="30" r="2" fill="#000" />
          <path d="M12 52q6-6 12 0M36 52q6-6 12 0" stroke="#000" strokeWidth="2" fill="none" />
        </mask>
        <mask id="pp-murcielago" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="76">
          <rect width="60" height="76" fill="#fff" />{marco}{borde}
          <path d="M30 24c-1-3-3-4-4-2-5-4-12-5-18-2 4 1 5 4 4 7 4-1 8 0 9 4 3-3 6-3 8 0 0-2 0-3 1-3s1 1 1 3c2-3 5-3 8 0 1-4 5-5 9-4-1-3 0-6 4-7-6-3-13-2-18 2-1-2-3-1-4 2z" fill="#000" />
          {[[16, 46], [30, 50], [44, 46]].map(([x, y]) => <path key={x} d={`M${x} ${y - 4}l3 4-3 4-3-4z`} fill="#000" />)}
        </mask>
        <mask id="pp-rombos" maskUnits="userSpaceOnUse" x="0" y="0" width="60" height="76">
          <rect width="60" height="76" fill="#fff" />{marco}{borde}
          {[12, 24, 36, 48].flatMap((y, r) => [12, 24, 36, 48].map((x) => (r + x / 12) % 2 ? null : <path key={`${x}-${y}`} d={`M${x} ${y - 5}l5 5-5 5-5-5z`} fill="#000" />))}
          <circle cx="30" cy="30" r="7" fill="#000" /><circle cx="30" cy="30" r="3" fill="#fff" />
        </mask>
      </defs>
    </svg>
  );
}

export function PapelPicado({ n = 22, className = "" }) {
  return (
    <div className={`papel-picado ${className}`} aria-hidden="true">
      <DefsPapel />
      <span className="pp-cuerda" />
      {Array.from({ length: n }, (_, i) => (
        <svg key={i} className="pp-bandera" viewBox="0 0 60 76" style={{ animationDelay: `${-(i % 7) * 0.6}s`, animationDuration: `${3.2 + (i % 5) * 0.45}s` }}>
          <path d="M0 0h60v70l-5 6-5-6-5 6-5-6-5 6-5-6-5 6-5-6-5 6-5-6-5 6-5-6z" fill={COLORES_PP[i % COLORES_PP.length]} mask={`url(#pp-${MOTIVOS[i % MOTIVOS.length]})`} />
        </svg>
      ))}
    </div>
  );
}

// ─── CALAVERA DE AZÚCAR ───
export function Calavera({ className = "", tam }) {
  const petalos = (cx, cy, color, r = 30) => Array.from({ length: 10 }, (_, i) => {
    const a = (i / 10) * Math.PI * 2, x = cx + Math.cos(a) * r, y = cy + Math.sin(a) * r;
    return <ellipse key={i} cx={x} cy={y} rx="5.5" ry="9" transform={`rotate(${(a * 180) / Math.PI + 90} ${x} ${y})`} fill={i % 2 ? color : AMARILLO} />;
  });
  return (
    <svg className={`calavera ${className}`} viewBox="0 0 200 230" style={tam ? { width: tam } : undefined} aria-hidden="true">
      <defs>
        <radialGradient id="cal-hueso" cx="50%" cy="38%" r="65%"><stop offset="0" stopColor="#FFFDF8" /><stop offset="1" stopColor="#D9D2C5" /></radialGradient>
        <radialGradient id="cal-ojo" cx="50%" cy="50%" r="50%"><stop offset="0" stopColor={ROJO} stopOpacity=".95" /><stop offset=".35" stopColor={ROJO} stopOpacity=".35" /><stop offset="1" stopColor={NEGRO} stopOpacity="0" /></radialGradient>
      </defs>
      {/* cráneo */}
      <path d="M100 12C46 12 18 54 22 102c2 28 16 46 30 56l4 30c1 10 10 14 20 14h48c10 0 19-4 20-14l4-30c14-10 28-28 30-56 4-48-24-90-78-90z" fill="url(#cal-hueso)" />
      {/* frente: cempasúchil */}
      <g className="cal-flor">
        {Array.from({ length: 14 }, (_, i) => <ellipse key={i} cx="100" cy="36" rx="7" ry="15" transform={`rotate(${i * 25.7} 100 50)`} fill={i % 2 ? NARANJA : AMARILLO} />)}
        {Array.from({ length: 9 }, (_, i) => <ellipse key={`b${i}`} cx="100" cy="42" rx="5" ry="9" transform={`rotate(${i * 40} 100 50)`} fill={NARANJA} />)}
        <circle cx="100" cy="50" r="7" fill="#C2410C" />
      </g>
      {/* volutas moradas en las sienes */}
      <path d="M40 78c6-14 22-16 26-6 3 8-6 12-10 7" stroke={MORADO} strokeWidth="4" fill="none" strokeLinecap="round" />
      <path d="M160 78c-6-14-22-16-26-6-3 8 6 12 10 7" stroke={MORADO} strokeWidth="4" fill="none" strokeLinecap="round" />
      {/* ojos con pétalos */}
      {petalos(68, 112, ROSA)}{petalos(132, 112, MORADO)}
      <ellipse cx="68" cy="112" rx="21" ry="22" fill={NEGRO} /><ellipse cx="132" cy="112" rx="21" ry="22" fill={NEGRO} />
      <circle className="cal-pupila" cx="68" cy="114" r="14" fill="url(#cal-ojo)" /><circle className="cal-pupila" cx="132" cy="114" r="14" fill="url(#cal-ojo)" />
      <circle cx="68" cy="114" r="3" fill={ROJO} /><circle cx="132" cy="114" r="3" fill={ROJO} />
      {/* nariz: corazón al revés */}
      <path d="M100 160c-3-5-12-8-12-15 0-4 3-7 7-7 2 0 4 1 5 3 1-2 3-3 5-3 4 0 7 3 7 7 0 7-9 10-12 15z" fill={NEGRO} transform="rotate(180 100 149)" />
      {/* mejillas */}
      {[[44, 146, NARANJA], [156, 146, NARANJA], [50, 158, MORADO], [150, 158, MORADO], [40, 134, ROSA], [160, 134, ROSA]].map(([x, y, c]) => <circle key={`${x}${y}`} cx={x} cy={y} r="4" fill={c} />)}
      {/* boca cosida */}
      <path d="M62 178h76" stroke={NEGRO} strokeWidth="3" strokeLinecap="round" />
      {Array.from({ length: 9 }, (_, i) => <path key={i} d={`M${66 + i * 8.5} 171v14`} stroke={NEGRO} strokeWidth="2.4" strokeLinecap="round" />)}
      {/* barbilla: corazón rojo */}
      <path d="M100 206c-2-3-8-5-8-10 0-3 2-5 5-5 1 0 2 1 3 2 1-1 2-2 3-2 3 0 5 2 5 5 0 5-6 7-8 10z" fill={ROJO} />
    </svg>
  );
}

// ─── MURCIÉLAGOS ───
const BAT = "M50 18c-2-6-5-8-7-4-10-7-24-9-36-3 7 2 9 7 8 12 8-2 15 0 17 8 6-6 11-6 15 0 1-3 1-6 3-6s2 3 3 6c4-6 9-6 15 0 2-8 9-10 17-8-1-5 1-10 8-12-12-6-26-4-36 3-2-4-5-2-7 4z";
const VUELOS = [
  { top: "14%", dur: 16, delay: 0, s: 1 },
  { top: "28%", dur: 21, delay: -7, s: 0.7 },
  { top: "9%", dur: 25, delay: -14, s: 0.55 },
  { top: "40%", dur: 19, delay: -3, s: 0.85 },
  { top: "58%", dur: 27, delay: -18, s: 0.6 },
];
export function Murcielagos() {
  return (
    <div className="murcielagos" aria-hidden="true">
      {VUELOS.map((v, i) => (
        <span key={i} className="mc-vuelo" style={{ top: v.top, animationDuration: `${v.dur}s`, animationDelay: `${v.delay}s`, "--s": v.s }}>
          <svg className="mc" viewBox="0 0 100 40" style={{ animationDelay: `${i * 0.13}s` }}><path d={BAT} /></svg>
        </span>
      ))}
    </div>
  );
}

// ─── PÉTALOS DE CEMPASÚCHIL ───
const PETALOS = Array.from({ length: 18 }, (_, i) => ({
  left: (i * 37) % 100, dur: 11 + ((i * 7) % 9), delay: -((i * 3.1) % 18), dx: ((i % 5) - 2) * 6, tam: 9 + (i % 4) * 3, color: i % 3 ? NARANJA : AMARILLO,
}));
export function Petalos() {
  return (
    <div className="petalos" aria-hidden="true">
      {PETALOS.map((p, i) => (
        <svg key={i} className="petalo" viewBox="0 0 20 28" style={{ left: `${p.left}%`, width: p.tam, animationDuration: `${p.dur}s`, animationDelay: `${p.delay}s`, "--dx": `${p.dx}vw` }}>
          <path d="M10 1C4 7 2 14 4 20c2 5 10 6 12 0 2-6 0-13-6-19z" fill={p.color} />
          <path d="M10 4v20" stroke="#C2410C" strokeWidth=".8" opacity=".6" />
        </svg>
      ))}
    </div>
  );
}

// ─── OFRENDA: velas encendidas y flores ───
export function Ofrenda({ n = 9 }) {
  return (
    <div className="ofrenda" aria-hidden="true">
      {Array.from({ length: n }, (_, i) => (
        i % 2 ? (
          <svg key={i} className="of-flor" viewBox="0 0 40 40">
            {Array.from({ length: 10 }, (_, k) => <ellipse key={k} cx="20" cy="9" rx="4" ry="9" transform={`rotate(${k * 36} 20 20)`} fill={k % 2 ? NARANJA : AMARILLO} />)}
            <circle cx="20" cy="20" r="5" fill="#C2410C" />
          </svg>
        ) : (
          <span key={i} className="of-vela" style={{ "--h": `${44 + (i * 13) % 36}px`, animationDelay: `${-i * 0.37}s` }}>
            <i className="of-llama" /><i className="of-cuerpo" />
          </span>
        )
      ))}
    </div>
  );
}

// ─── CALAVERITA LITERARIA ───
export const CALAVERITA = [
  "Llegó la Flaca al estudio",
  "con su vestido de gala,",
  "venía por todo el equipo",
  "con su guadaña y su pala.",
  "Pero vio el visor prendido",
  "y se quedó a la función;",
  "pidió un spot de su vida",
  "filmado con corazón.",
  "Ahora sale en los créditos",
  "y no regresa al panteón,",
  "porque aquí todo es a mano",
  "y nada es de imitación.",
];

// ─── ALTAR DE MUERTOS DEL CINE ───
// Arco de cempasúchil sobre el altar
export function ArcoFlores() {
  const n = 25;
  return (
    <svg className="arco-flores" viewBox="0 0 1000 260" preserveAspectRatio="xMidYMax meet" aria-hidden="true">
      <path d="M40 255 C40 40 960 40 960 255" fill="none" stroke="#3b2a12" strokeWidth="6" />
      {Array.from({ length: n }, (_, i) => {
        const t = i / (n - 1), x = (1 - t) ** 3 * 40 + 3 * (1 - t) ** 2 * t * 40 + 3 * (1 - t) * t * t * 960 + t ** 3 * 960;
        const y = (1 - t) ** 3 * 255 + 3 * (1 - t) ** 2 * t * 40 + 3 * (1 - t) * t * t * 40 + t ** 3 * 255;
        const r = 17 + (i % 3) * 3;
        return (
          <g key={i} transform={`translate(${x} ${y})`}>
            {Array.from({ length: 10 }, (_, k) => <ellipse key={k} cx="0" cy={-r * 0.55} rx={r * 0.32} ry={r * 0.55} transform={`rotate(${k * 36})`} fill={k % 2 ? NARANJA : AMARILLO} />)}
            <circle r={r * 0.3} fill="#C2410C" />
          </g>
        );
      })}
    </svg>
  );
}

// Retrato del altar: sin fotos, solo el nombre en un marco, con su vela
export function Retrato({ p }) {
  return (
    <figure className="retrato">
      <span className="of-vela retrato-vela" style={{ "--h": "34px" }}><i className="of-llama" /><i className="of-cuerpo" /></span>
      <div className="retrato-marco">
        <span className="retrato-anios">{p.anios}</span>
        <b className="retrato-nombre">{p.nombre}</b>
        <span className="retrato-rol">{p.rol}</span>
        {p.recuerdo && <span className="retrato-recuerdo">{p.recuerdo}</span>}
      </div>
    </figure>
  );
}
